import { merchandisingLabels } from '@/core/tamagoshi/MerchandisingTag/interfaces';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import { getTags } from '@/productDiscovery/CommercialAnimation/utils/getProductPromoTags';

export interface UsePromotionLabels {
  hasPromoLabel: boolean;
  hasBlackfridayLabel?: boolean;
  hasSalesLabel?: boolean;
  hasManoManoDaysLabel?: boolean;
  hasLoweredPriceLabel?: boolean;
}

export const usePromotionLabels = (): UsePromotionLabels => {
  const { commercialAnimation, price } = useDetail();

  const promoTags = getTags(
    price.primaryPrice.amountWithVat,
    price.retailPrice?.amountWithVat ?? 0,
    commercialAnimation?.tags,
  );

  const hasPromoLabel =
    promoTags.includes(merchandisingLabels.PROMO) &&
    Boolean(price?.discountPercentage) &&
    Boolean(price?.retailPrice);

  const hasBlackfridayLabel =
    hasPromoLabel && promoTags.includes(merchandisingLabels.BLACKFRIDAY);

  const hasSalesLabel =
    hasPromoLabel && promoTags.includes(merchandisingLabels.SALES);

  const hasManoManoDaysLabel =
    hasPromoLabel && promoTags.includes(merchandisingLabels.MANOMANODAYS);

  const hasLoweredPriceLabel = promoTags.includes(
    merchandisingLabels.LOWERED_PRICE,
  );

  return {
    hasPromoLabel,
    hasBlackfridayLabel,
    hasSalesLabel,
    hasManoManoDaysLabel,
    hasLoweredPriceLabel,
  };
};
